<div mat-dialog-title>
  <span>Request API Key</span>
</div>


<mat-dialog-content [formGroup]="form">
  <mat-form-field appearance="outline" class="wide">
    <mat-label>Reason</mat-label>
    <textarea matInput rows="3" cdkTextareaAutosize cdkAutosizeMaxRows="3" cdkAutosizeMinRows="3"
              formControlName="description" maxlength="1000">
    </textarea>
    <mat-error>
      @if (form.get('description')?.hasError("required")) {
        <span>A reason is required</span>
      }
    </mat-error>
  </mat-form-field>

  <div class="supported-systems-section">
    <div class="supported-systems-header">
      <span>Supported Systems</span>
    </div>
    <div formArrayName="supportedSystems" class="supported-syst ems-list">
      @for (control of supportedSystems.controls; track $index; let i = $index) {
        <div class="supported-system-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>System {{ i + 1 }}</mat-label>
            <input matInput [formControlName]="i" maxlength="255"/>
            <mat-error>
              @if (control.hasError("required")) {
                <span>A system name is required</span>
              }
            </mat-error>
          </mat-form-field>
          @if (i !== 0) {
            <button mat-icon-button color="warn" type="button" (click)="removeSupportedSystem(i)">
              <vulcan-icon icon="trash" size="24px"/>
            </button>
          }
        </div>
      }
      <div>
        <button mat-stroked-button type="button" (click)="addSupportedSystem()"> Add System</button>
      </div>

    </div>
  </div>


  <div class="terms-of-use">
    <span>TERMS OF USE</span>
    <ul>
      <li> Attribution: https://tasti-grid.doe.gov</li>
      <li> Allowed publishing or distribution is allowed for data summaries or derived data as long as the attribution
        noted above is preserved.
      </li>
      <li> Similar data publishing and distribution limitations are required for non-DOE users of TASTI-GRID data.</li>
    </ul>
  </div>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="saving || form.invalid" (click)="save()">
    {{ saving ? "Sending..." : "Submit Request" }}
  </button>
</mat-dialog-actions>
